import LegalShell from "./LegalShell";

export default function Cookies() {
    return (
        <LegalShell
            title="Çerez Politikası"
            subtitle="Sayz panelinde ve merchant sitelerinde yüklenen widget'ta hangi çerezlerin kullanıldığını ve bunları nasıl yönetebileceğinizi açıklar."
            lastUpdated="24 Şubat 2026"
            testId="legal-cookies"
        >
            <p className="lead">
                Sayz, hizmetlerini sunmak ve iyileştirmek için minimum sayıda çerez ve
                yerel depolama (localStorage) öğesi kullanır. Reklam veya üçüncü taraf
                takip çerezi <strong>kullanılmaz</strong>.
            </p>

            <h2>1. Çerez Kategorileri</h2>

            <h3>Zorunlu Çerezler (Her Zaman Aktif)</h3>
            <p>
                Hizmetin temel işlevi için gereklidir. Devre dışı bırakılırsa panel
                çalışmaz. Rıza gerektirmez (ePrivacy Direktifi istisnası).
            </p>
            <ul>
                <li><code>sayz_session</code> — oturum token'ı (HTTPOnly, Secure, SameSite=Lax)</li>
                <li><code>csrf_token</code> — Double-submit CSRF koruması</li>
                <li><code>sayz_admin_session</code> — süperadmin oturumu (yalnızca admin paneli)</li>
            </ul>

            <h3>İşlevsellik (Opsiyonel — Rıza Gerektirir)</h3>
            <p>
                Ziyaretçi tecrübesini iyileştirir. Reddedilirse hizmet çalışır ama
                her ürünü yeniden sorulur.
            </p>
            <ul>
                <li>
                    <code>sayz_fms_profile</code> (<strong>localStorage</strong>, merchant sitesinde) —
                    Smart Recall özelliği için kullanıcının boy/kilo/yaş/fit tercihleri.
                    Yalnızca ziyaretçinin kendi tarayıcısında saklanır,{" "}
                    <strong>Sayz sunucularına aktarılmaz</strong>.
                </li>
            </ul>

            <h3>Analitik Çerezler</h3>
            <p>
                Sayz, Google Analytics veya benzeri üçüncü taraf analitik çerezleri{" "}
                <strong>kullanmaz</strong>. Panelde yalnızca kendi aggregate
                sayaçlarımızı tutarız (<code>widget_events</code>,{" "}
                <code>widget_query_log</code>) — bu veriler sunucu tarafında işlenir,
                ziyaretçinin tarayıcısında çerez bırakmaz.
            </p>

            <h3>Pazarlama Çerezleri</h3>
            <p>
                <strong>Kullanılmaz.</strong> Üçüncü taraf reklam ağları, piksel'ler veya
                remarketing tag'leri ne panelde ne de widget'ta bulunmaz.
            </p>

            <h2>2. Çerezleri Yönetme</h2>
            <p>
                Çoğu tarayıcı çerezleri kabul edecek şekilde yapılandırılmıştır ancak
                aşağıdaki yollarla kontrolü siz sağlayabilirsiniz:
            </p>
            <ul>
                <li><strong>Tarayıcı ayarları:</strong> Çerezleri reddedebilir, mevcutları silebilirsiniz. Her tarayıcının yöntemi farklıdır (<a href="https://support.google.com/accounts/answer/32050" target="_blank" rel="noreferrer">Chrome</a>, Firefox, Safari).</li>
                <li><strong>Çerez banner'ı:</strong> İlk ziyarette görünen banner'daki "Reddet" seçeneği ile opsiyonel çerezleri kapatabilirsiniz.</li>
                <li><strong>Smart Recall:</strong> Merchant panelinden Smart Recall özelliğini kapatarak ziyaretçilerin tarayıcısına <code>sayz_fms_profile</code> yazılmasını engelleyebilirsiniz.</li>
            </ul>

            <h2>3. Rıza Yönetimi</h2>
            <p>
                Opsiyonel çerezler için ziyaretçi rızası alınır. Rıza her zaman geri alınabilir —
                tarayıcı önbelleğini temizlemek yeterlidir. Zorunlu çerezler için rıza
                gerekmez (hizmetin ifası için zorunlu).
            </p>

            <h2>4. Üçüncü Taraf Hizmetler</h2>
            <p>
                Hizmetin sunulması için aşağıdaki altyapı sağlayıcılarını kullanırız;
                bunlar kendi gizlilik politikalarına tabidir ve kullanıcı tarayıcısında
                çerez bırakmaz:
            </p>
            <ul>
                <li>AWS CloudFront (CDN)</li>
                <li>Emergent Platform (barındırma)</li>
            </ul>

            <h2>5. Değişiklikler</h2>
            <p>
                Bu politikayı güncelediğimizde son güncelleme tarihi sayfanın başında
                belirtilir. Önemli değişiklikler için panel içi bildirim gönderilir.
            </p>

            <h2>6. İletişim</h2>
            <p>
                Sorularınız için:{" "}
                <a href="mailto:hello@atamis.global">hello@atamis.global</a>
            </p>
        </LegalShell>
    );
}
